import React, { useState, useRef } from "react";
import { AuthServices } from "../services/AuthServices";
import { useNavigate } from "react-router-dom";

const VerifyOtp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputsRef = useRef([]);
  const navigate = useNavigate();

  const handleChange = (value, index) => {
    if (value.length === 6) {
      const digits = value.split("").slice(0, 6);
      setOtp(digits);

      inputsRef.current[5].focus();
      return;
    }

    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const submitOtp = async () => {
    const code = otp.join("");

    if (code.length !== 6) {
      setError("Please enter the full 6-digit code.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const email = localStorage.getItem("data");
      const parsedEmail = JSON.parse(email);
      const { businessEmail } = parsedEmail
      const type = localStorage.getItem("type");

      const response = await AuthServices.verifyEmailToken(
        code,
        businessEmail,
        type,
      );
      if (!response.success) {
        setError(response.message);
        return;
      }
      if (response.data?.accountStatus?.approvedByAdmin) {
        navigate("/manager/dashboard");
        return;
      }
      if (response.data?.accountStatus?.emailVerified) {
        window.location.replace("/register/account-setup");
        return;
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <h2 style={styles.title}>Enter Verification Code</h2>
      <p style={styles.subtitle}>We sent a 6-digit code to your email.</p>

      <div style={styles.otpContainer}>
        {otp.map((digit, idx) => (
          <input
            onPaste={(e) => {
              const pasted = e.clipboardData.getData("text");
              handleChange(pasted, 0);
            }}
            key={idx}
            ref={(el) => (inputsRef.current[idx] = el)}
            type="text"
            value={digit}
            maxLength={1}
            onChange={(e) => handleChange(e.target.value, idx)}
            onKeyDown={(e) => handleKeyDown(e, idx)}
            style={styles.otpBox}
          />
        ))}
      </div>
      {error && <p style={styles.error}>{error}</p>}

      <button onClick={submitOtp} disabled={loading} style={styles.button}>
        {loading ? "Verifying..." : "Verify Code"}
      </button>

      <br />
      <p>
        Please check your spam/junk folder if you don't see the email in your
        inbox.
      </p>
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    boxSizing: "border-box",
  },
  title: {
    fontSize: "24px",
    marginBottom: "10px",
    color: "#333",
  },
  subtitle: {
    fontSize: "14px",
    marginBottom: "20px",
    color: "#666",
  },
  otpContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "20px",
  },
  otpBox: {
    width: "45px",
    height: "55px",
    fontSize: "24px",
    textAlign: "center",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  error: {
    color: "red",
    marginBottom: "10px",
    textAlign: "center",
  },
  button: {
    width: "100%",
    maxWidth: "250px",
    padding: "12px",
    backgroundColor: "#f0904a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default VerifyOtp;
